import { Component, Inject, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { MatDialogRef, MatSelect, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { ForwardContractService } from '../../../../../../core/services/forward-contract.service';
import { UserGroupService } from '../../../../../../core/services/user-group.service';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';

@Component({
  selector: 'app-forward-contract-dialog',
  templateUrl: './forward-contract-dialog.component.html',
  styleUrls: ['./forward-contract-dialog.component.scss']
})
export class ForwardContractDialogComponent implements OnInit {
  mainFormGroup: FormGroup;
  filteredOptions: any[] = [];
  enterprises: any[] = [];

  isShowResult = false;
  countSuccess = 0;
  countError = 0;
  listErrorUser = [];
  @ViewChild('f', {static: false}) ngForm: NgForm;
  formChangesSubscription: Subscription;
  isLoading = false;
  searchValue = '';
  columnDefinitions = [
    {def: 'fullName', showXS: true, showSM: true, showMD: true},
    {def: 'description', showXS: true, showSM: true, showMD: true},
];
displayedColumns: string[] = [];
public mediaBreakpoint: any;
public subscribeMediaBreakPointService: Subscription;
public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public dialogRef: MatDialogRef<ForwardContractDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserGroupService,
    private forwardContractService: ForwardContractService,
    private toastr: ToastrService,
    public message: Message,
    private fb: FormBuilder,
    public autoEnterpriseService: AutoEnterpriseService,
    
  ) { 
    this.getDisplayedColumns();
  }

  ngOnInit() {

    this.mainFormGroup = this.fb.group({
      userSearch: new FormControl('', []),
      user: new FormControl([]),
      note: new FormControl('', []),
    });
    // On init lấy 10 user mặc định
    this.isLoading = true;
    this.autoEnterpriseService.searchUserOrDepartment('')
    .then(result => {
      this.filteredOptions = [];
      if (result) {
        this.filteredOptions = result;
        console.log(result);
      }
    }).finally(() => {
      this.isLoading = false;
    });

    // Khi tìm kiếm thì search user
    this.mainFormGroup.get('userSearch').valueChanges.pipe(
      filter(res => {
        if (res !== null) {
          this.isLoading = true;
        }
        return res !== null;
      }),
      distinctUntilChanged(),
      debounceTime(300),
      tap(() => {
        this.enterprises = [];
      })).subscribe((value) => {
        this.autoEnterpriseService.searchUserOrDepartment(value.trim())
          .then(result => {
            this.filteredOptions = [];
            if (result) {
              this.filteredOptions = result;
              console.log(result);
            }
          }).finally(() => {
            this.isLoading = false;
          });
      });
  }

  // ngOnDestroy() {
  //   this.formChangesSubscription.unsubscribe();
  // }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
        this.displayedColumns = this.columnDefinitions
            .filter(cd => cd.showXS)
            .map(cd => cd.def);
    } else {
        if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
            this.displayedColumns = this.columnDefinitions
                .filter(cd => cd.showMD)
                .map(cd => cd.def);
        } else {
            this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
        }
    }
  }

  ngAfterViewInit() {
    // setTimeout(_ => this.select.focus());
  }

  onNoClick() {
    this.dialogRef.close();
  }

  // Chuyển tiếp
  forwardContract(): void {
    const listUser = [];
    if (this.mainFormGroup.get('user').value.length > 0) {
      this.mainFormGroup.get('user').value.forEach(element => {
        listUser.push({id: element.id ? element.id : element.departmentId, fullName: element.fullName, receiveType: element.type});
      });
    }
      const body = {
        contractId: this.data.data.id,
        receiverId: listUser,
        note: this.mainFormGroup.get('note').value.trim()
      }
      console.log(body)
      this.forwardContractService.forwardContract(body).subscribe(res => {
        if (res.success) {
          this.isShowResult = true;
          this.countSuccess = res.data.successCount;
          this.countError = res.data.forwardError.length;
          this.listErrorUser = res.data.forwardError;
          if (this.countSuccess > 0) {
            this.toastr.success(this.message.getMessage('messages.forward_contract_success'));
          } else {
            this.toastr.error(this.message.getMessage('messages.forward_contract_error'));
          }
          // this.dialogRef.close();
        } else {
          this.toastr.error(this.message.getMessage('messages.forward_contract_error'));
        }
      });
  }

  focusOut(field: string) {
    const value = this.mainFormGroup.get(field).value
      ? this.mainFormGroup.get(field).value.trim()
      : null;
    if (field === 'cpCode') {
      value.toUpperCase();
    }
    this.mainFormGroup.get(field).patchValue(value);
  }

  // Chọn user
  onSelectUser(event: any) {
    console.log(event);
    const user = this.filteredOptions.find(item => item.id === event.option.value || item.departmentId === event.option.value);
    const users = this.mainFormGroup.get('user').value;
    users.push(user);
    this.mainFormGroup.get('user').patchValue(users);
    this.mainFormGroup.get('userSearch').patchValue('');
  }

  // Xóa user
  removeUser(userRemove: any) {
    let users = this.mainFormGroup.controls.user.value;
    users = users.filter(user => {
      if(userRemove.type === 'USER') {
        return user.id !== userRemove.id;
      } else {
        return user.departmentId !== userRemove.departmentId;
      }
    });
    this.mainFormGroup.controls.user.patchValue(users);
  }

  checkUserExist(id) {
    const users = this.mainFormGroup.get('user').value;
    const check = users.find(user => user.id === id || user.departmentId === id);
    return !!check;
  }
}

